import { render } from "./DocLink.vue?vue&type=template&id=92e6adde&scoped=true"
import script from "./DocLink.vue?vue&type=script&lang=js"
export * from "./DocLink.vue?vue&type=script&lang=js"

import "./DocLink.vue?vue&type=style&index=0&id=92e6adde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e6adde"]])

export default __exports__